export default __webpack_public_path__ + "static/media/service06.9e948355.png";